import React from "react";
import Link from "gatsby-link";
import Chilling from "../images/chilling.svg";

const AboutPage = () => (
  <div className="flex flex-col md:flex-row items-center">
    <div className="md:w-2/3 md:mr-8">
      <p className="border-l-4 border-grey-darkest font-serif leading-loose pl-4 text-justify">
        Value in computer and software design lies in simplicity
      </p>
      <p className="font-bold mt-4 text-left text-xs uppercase">
      Founded in 2009, 24/7 Software is the sole proprietorship of
      Andrew Bruce, P.Eng. Specializing in mobile app and custom
      hardware and software solutions. Contact me today to chat about your
      project.
      </p>
    </div>

    <div className="w-2/3 md:w-1/3">
      <img src={Chilling} />
    </div>
  </div>
);

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about.js